module.exports = __webpack_public_path__ + "img/icon-mail.d4d84c33.svg";